module.exports = __webpack_public_path__ + "5c50d54518616ca7747b6a591c4dcb52.fbx";